import { Component, OnInit } from '@angular/core';
import { EnergyDataService } from '../../energy-data/energy-data.service';
import { LdsUserService } from '../../services/lds-user.service';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
@Component({
    selector: 'lds-featureset-list',
    templateUrl: './featureset-list.component.html',
    styleUrls: ['./featureset-list.component.css'],
    standalone: false
})
export class FeaturesetListComponent implements OnInit {

  featureSetsWithData = []

  constructor(public user: LdsUserService, public energyData: EnergyDataService, private eb: LdsEventBusService) { }

  ngOnInit() {
    this.eb.subscribe('energySummary-featureSets-loaded', (data) => {
      if (data) {
        this.featureSetsWithData = this.energyData.featureSetsWithData.sort((a,b) => {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })
      }
    })
  }

}
